import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '@components/not-found/not-found.component';
import { ROUTER_UTILS } from '@core/utils/router.utils';

const APP_ROUTES: Routes = [
  // {
  //   path: ROUTER_UTILS.config.base.home,
  //   loadChildren: async () =>
  //     (await import('src/app/features/tracking/tracking.module')).TrackingModule
  // },
  // {
  //   path: '**',
  //   loadChildren: async () =>
  //     (await import('@shell/ui/not-found/not-found.module')).NotFoundModule,
  //   component: NotFoundComponent
  // },
];

@NgModule({
  imports: [
    CommonModule,
    // RouterModule.forRoot(APP_ROUTES),
  ],
  exports: [
    // RouterModule,
  ],
})
export class WebShellModule {}
